import { Tabs, TabsList, TabsTrigger, TabsContent, SheetFooter, Button } from 'twyne-new.ui';

import { useConsentDBAsContext } from '@/components/ConsentDBAs/Context';
import DefaultConsentDBAs from '@Components/ConsentDBAs';
import DefaultDBATab from '@Components/ConsentDBAs/Tabs/DBA';
import DefaultHelperTab from '@Components/ConsentDBAs/Tabs/Helper';

export default function ConsentDBAs({ data, onChange }) {
  return <DefaultConsentDBAs>
    <Tabs defaultValue='dbas'>
      <TabsList>
        <TabsTrigger className='pt-0' value='dbas'>DBAs</TabsTrigger>
        <TabsTrigger className='pt-0' value='helpers'>Helpers</TabsTrigger>
      </TabsList>
      <TabsContent value='dbas'>
        <DBAsTab data={data} onChange={onChange} />
      </TabsContent>
      <TabsContent value='helpers'>
        <HelpersTab />
      </TabsContent>
    </Tabs>
  </DefaultConsentDBAs>
}

function DBAsTab({ data, onChange }) {
  return <DefaultDBATab data={data} onChange={onChange} valueDisabled />
}

function HelpersTab() {
  const { modal: { toggle } } = useConsentDBAsContext()

  return <DefaultHelperTab helpers={HELPERS}>
    <div className='font-semibold mb-4'>These helpers is used for TCPA Consent DBA, use it change the way the checkbox of each dba is displayed. You can copy and paste on TCPA Consent Text.</div>
    <SheetFooter className='absolute bottom-0 w-full left-0 right-0'>
      <Button color='neutral' variant='ghost' onClick={toggle}>Cancel</Button>
    </SheetFooter>
  </DefaultHelperTab>
}

const HELPERS = [{
  id: `dba`,
  label: `A simple way for rendering TCPA consent without additional content.`,
  height: `40px`,
  content: `{{{dbas class='custom-dba' defaultChecked=true}}}`,
  annotations: [
    { row: 0, text: `This helper, when used without content, must be called with three curly braces.` },
  ],
}, {
  id: `group-dba`,
  label: `A helper that groups TCPA consent content with customizable HTML elements.`,
  height: `90px`,
  content: `{{#dbas defaultChecked=true}}
  <span class='custom-group'>
    {{{dbas_group}}}
  </span>
{{/dbas}}`,
  annotations: [
    { row: 0, text: `When calling {{dbas}} with content, it must use two curly braces and a '#'` },
    { row: 1, text: `The content can be any HTML element, not just a <span>.` },
    { row: 1, text: `You can customize a class to match your styling needs.` },
    { row: 2, text: `Inside this block, the {{dbas_group}} helper is used to render all DBA's.` },
    { row: 2, text: `This helper must be called with three curly braces.` },
  ],
}, {
  id: `item-dba`,
  label: `A complex structure for rendering TCPA consent with grouped items and custom input fields.`,
  height: `160px`,
  content: `{{#dbas defaultChecked=true}}
  <span class='custom-group'>
    {{#dbas_group}}
      <span class='custom-item'>
        {{{dba_input class='custom-input'}}}
        {{{dba_label class='custom-label'}}}
      </span>
    {{/dbas_group}}
  </span>
{{/dbas}}`,
  annotations: [
    { row: 0, text: `When calling {{dbas}} with content, it must use two curly braces and a '#'.` },
    { row: 2, text: `When calling {{dbas_group}} with content, it must use two curly braces and a '#'.` },
    { row: 3, text: `Here, an HTML element like <span> is used to group elements.` },
    { row: 3, text: `You can customize the elements with a class.` },
    { row: 4, text: `The {{{dba_input}}} and {{{dba_label}}} helpers must be called with three curly braces.` },
  ],
}]
